import Switch from '@material-ui/core/Switch';
import Typography from "@mui/material/Typography";
import React, { useMemo } from 'react';

const CreateTriggerHeader = ({ closeModal,formik,onSubmit,isLoading }) => {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const isDisabled = useMemo(() => {
    return !formik.isValid || !formik.dirty || isLoading;
  }, [formik.isValid, formik.dirty, isLoading]);

  return (
    <>
      <div className="add-group-header update__user__header mt-5">
        <Typography variant="h5" gutterBottom>
          New Task Automation
        </Typography>
        <div className="user__header__action">
          <button
            className="cancel_user_btn"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="save_user_btn btn btn-primary"
            onClick={onSubmit}
            disabled={isDisabled}
          >
            <span className="user_btn_text">Save</span>
            {isLoading && (
              <span className="ml-3 spinner spinner-white"></span>
            )}
          </button>
        </div>
      </div>
      <div className="active">
        <span>Is this trigger active?</span>
        <Switch {...label} 
           checked={formik.values?.active ? true : false}
           onChange={(event) => {
             const { checked } = event.target;
             formik.setFieldValue("active", checked);
           }}
        />
      </div>
    </>
  )
}

export default CreateTriggerHeader